<script>
  export let textColor
</script>

<style>
  .kbz_reviews_card {
    background: #fff;
    margin: 10px 10px 30px 10px;
    width: 350px !important;
    height: 145px !important;
    box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.03);
    border-radius: 7px;
    padding: 20px;
    position: relative;
  }

  .kbz_reviews_card_body {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .review-content {
    line-height: 1.3;
    font-style: italic;
    position: absolute;
    top: 45%;
  }
</style>

<div class="$style.kbz_reviews_card">
  <div class="$style.kbz_reviews_card_body">
    <div class="$style.review-content" style="color: {textColor};">
      Publish some reviews
    </div>
  </div>
</div>
